import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import intlMessages from '../../../intl/messages';

export const HowToSolve: FC = () => (
  <div className='rounded border border-slate-300 dark:bg-slate-800 my-4'>
    <div className='p-5'>
      <h4 className='text-2xl font-bold mb-3'>
        🧠 <FormattedMessage {...intlMessages.howToSolveNonogram} />
      </h4>
      <p className='text-left mb-3'>
        <FormattedMessage {...intlMessages.howToSolveNonogramDescription} />
      </p>
      <p className='text-left'>
        <FormattedMessage {...intlMessages.howToSolveNonogramInstructions} />
      </p>
    </div>
  </div>
);
